/**
 * @format
 */

import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'state/store';
import { AffiliateSummaryContainer, AffiliateLeaderboardContainer } from 'features/affiliate-performance';
import { Layout } from 'features/layout';
import OfficeNames from 'components/officeNames';

import { setActiveStatsTab } from 'state/slice/tabSlice';
import { toggleForm } from 'state/slice/buttonSlice';
import DownArrow from 'img/ArrowLineDown.png';

const AffiliatePerformance: React.FC = () => {
  const dispatch = useDispatch();
  const selectedOfficeId = useSelector((state: RootState) => (state as any).dropDown?.officeId);
  const startDate = useSelector((state: RootState) => (state as any).dropDown?.startDate);
  const endDate = useSelector((state: RootState) => (state as any).dropDown?.endDate);
  const activeStatsTab = useSelector((state: RootState) => (state as any).activeTab?.activeStatsTab);
  const userFormActive = useSelector((state: RootState) => (state as any).button?.addUserForm);

  // Memoize the officeId and dates to prevent unnecessary re-renders
  const officeId = useMemo(() => selectedOfficeId, [selectedOfficeId]);
  const memoizedStartDate = useMemo(() => startDate, [startDate]);
  const memoizedEndDate = useMemo(() => endDate, [endDate]);

  const handleStatsTab = (tab: string) => {
    dispatch(setActiveStatsTab(tab));
  };

  const handleForm = (state: boolean) => {
    dispatch(toggleForm(state));
  };

  return (
    <Layout>
      <div className='affilliates-content-container'>
        <div className='a-p-tab-wrapper'>
          <OfficeNames />
        </div>
        <div className='stats-container'>
          <div className='stats-header'>
            <div className='stats-tab-wrapper'>
              <span
                onClick={() => handleStatsTab('operation')}
                className={activeStatsTab === 'operation' ? 'active' : ''}>
                Operation Overview
              </span>
              <span
                onClick={() => handleStatsTab('agent')}
                className={activeStatsTab === 'agent' ? 'active' : ''}>
                Agent Overview
              </span>
            </div>
            <div>
             
            </div>
          </div>

          {activeStatsTab === 'operation' && officeId && (
            <AffiliateSummaryContainer officeId={officeId} />
          )}
          {activeStatsTab === 'operation' && !officeId && (
            <div style={{ padding: '40px', textAlign: 'center', color: '#666' }}>
              Please select an office to view the operation overview.
            </div>
          )}
          {activeStatsTab === 'agent' && officeId && (
            <AffiliateLeaderboardContainer officeId={officeId} startDate={memoizedStartDate} endDate={memoizedEndDate} />
          )}
          {activeStatsTab === 'agent' && !officeId && (
            <div style={{ padding: '40px', textAlign: 'center', color: '#666' }}>
              Please select an office to view the agent overview.
            </div>
          )}
        </div>
      </div>


    </Layout>
  );
};

export default AffiliatePerformance;
